import { appsettingConstants } from '../_constants';

export default function appsetting(state = {}, action) {
  switch (action.type) {

    case appsettingConstants.UPDATES_APP_SETTING_REQUEST:
      return {
        ...state,
        loading: true
      };
    case appsettingConstants.UPDATES_APP_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        updateAppSettingSuccess: true

      };
    case appsettingConstants.UPDATES_APP_SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };





    case appsettingConstants.GET_FEE_SETTING_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case appsettingConstants.GET_FEE_SETTING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        appFeeSettingList: action?.user,

      };
    case appsettingConstants.GET_FEE_SETTING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };









    case appsettingConstants.GET_APPSETTING_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case appsettingConstants.GET_APPSETTING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        appSettingList: action?.user,
      };
    case appsettingConstants.GET_APPSETTING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //add coin
    case appsettingConstants.CREATE_APPSETTING_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case appsettingConstants.CREATE_APPSETTING_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case appsettingConstants.CREATE_APPSETTING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //  update
    case appsettingConstants.UPDATE_APPSETTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case appsettingConstants.UPDATE_APPSETTING_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case appsettingConstants.UPDATE_APPSETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //delete
    case appsettingConstants.DELETE_APPSETTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case appsettingConstants.DELETE_APPSETTING_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case appsettingConstants.DELETE_APPSETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //update status
    case appsettingConstants.UPDATE_APPSETTING_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case appsettingConstants.UPDATE_APPSETTING_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action?.user,
      };
    case appsettingConstants.UPDATE_APPSETTING_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state
  }
}